import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import { UXFeedbackPrompt } from 'src/components/ux-feedback';
import RelevancyFeedback from '../feedback-relevancy';

type Props = {
  query: string;
  showRelevancyFeedback: boolean;
  showUXFeedback: boolean;
};

export const SearchResultsFeedback = (props: Props) => {
  const { query, showRelevancyFeedback, showUXFeedback } = props;

  const { t, market } = useAppContext();

  // Only show the prompt in supported markets
  if (!['se'].includes(market.code)) {
    return null;
  }

  if (showRelevancyFeedback) {
    return <RelevancyFeedback query={query} />;
  }

  if (showUXFeedback) {
    return (
      <UXFeedbackPrompt
        formId="searchUUPFeedback"
        storageId="pj:searchUXFeedbackTime"
        title={t('search', 'uup.prompt-title')}
        description={t('search', 'uup.prompt-description')}
        utilityTitle={t('search', 'uup.question-utility')}
        usabilityTitle={t('search', 'uup.question-usability')}
        presentationTitle={t('search', 'uup.question-presentation')}
      />
    );
  }

  return null;
};
